<div class="sidebar-brand">
  <img [routerLink]="['/']" src="/assets/images/main-icon.png" width="30" />
  <img [routerLink]="['/']" src="/assets/images/header-title.png" width="130"/>
  <ng-content select="[content]"></ng-content>
</div>
